module.exports = __webpack_public_path__ + "img/icons B_32.0a94609e.png";